var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.14865 6.86304C5.6074 6.86304 3.5473 8.92313 3.5473 11.4644V26.8022C3.5473 29.3435 5.6074 31.4036 8.14865 31.4036H29.6216C32.1629 31.4036 34.223 29.3435 34.223 26.8022V11.4644C34.223 8.92313 32.1629 6.86304 29.6216 6.86304H8.14865ZM7.88103 9.95387C7.96794 9.93858 8.05736 9.9306 8.14865 9.9306H29.6216C29.7129 9.9306 29.8024 9.93858 29.8893 9.95388L18.8852 17.29L7.88103 9.95387ZM6.61487 12.7965V26.8022C6.61487 27.6493 7.30157 28.336 8.14865 28.336H29.6216C30.4687 28.336 31.1554 27.6493 31.1554 26.8022V12.7965L19.7359 20.4095C19.2208 20.753 18.5496 20.753 18.0344 20.4095L6.61487 12.7965Z",
    fill: "#FCFCFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/emailIcon.52a0550bb7e5957ec43c1c700eda3cf5.svg";
export { ForwardRef as ReactComponent };